import { FormLayoutGroup } from '@customerio/pluma-components/react';
import { TextField } from '@/components/form';
import type { FormApi } from './types';

const FIELD_CONFIG = {
  privacyPolicyUrl: { label: 'Privacy policy', placeholder: 'https://example.com/privacy' },
  termsOfServiceUrl: { label: 'Terms of service', placeholder: 'https://example.com/terms' },
  pricingUrl: { label: 'Pricing', placeholder: 'https://example.com/pricing' },
  downloadUrl: { label: 'Download', placeholder: 'https://example.com/download' },
} as const;

interface KeyLinksFieldsProps<TFormData> {
  form: FormApi<TFormData>;
  isDisabled?: boolean;
  fields?: Array<'privacyPolicyUrl' | 'termsOfServiceUrl' | 'pricingUrl' | 'downloadUrl'>;
}

export function KeyLinksFields<
  TFormData extends {
    privacyPolicyUrl?: string;
    termsOfServiceUrl?: string;
    pricingUrl?: string;
    downloadUrl?: string;
  },
>({
  form,
  isDisabled = false,
  fields = ['privacyPolicyUrl', 'termsOfServiceUrl', 'pricingUrl', 'downloadUrl'],
}: KeyLinksFieldsProps<TFormData>) {
  const fieldElements = fields.map((fieldName) => {
    const config = FIELD_CONFIG[fieldName];
    if (config == null) return null;

    return (
      <TextField
        key={fieldName}
        name={fieldName}
        api={form}
        label={config.label}
        placeholder={config.placeholder}
        isDisabled={isDisabled}
      />
    );
  });

  return <>{fields.length === 2 ? <FormLayoutGroup>{fieldElements}</FormLayoutGroup> : <>{fieldElements}</>}</>;
}
